export const FETCH_COURSE_CONTENTS_REQUEST = 'FETCH_COURSE_CONTENTS_REQUEST';
export const FETCH_COURSE_CONTENTS_SUCCESS = 'FETCH_COURSE_CONTENTS_SUCCESS';
export const FETCH_COURSE_CONTENTS_FAILURE = 'FETCH_COURSE_CONTENTS_FAILURE';

export const FETCH_COURSE_CONTENT_REQUEST = 'FETCH_COURSE_CONTENT_REQUEST';
export const FETCH_COURSE_CONTENT_SUCCESS = 'FETCH_COURSE_CONTENT_SUCCESS';
export const FETCH_COURSE_CONTENT_FAILURE = 'FETCH_COURSE_CONTENT_FAILURE';

export const CREATE_COURSE_CONTENT_REQUEST = 'CREATE_COURSE_CONTENT_REQUEST';
export const CREATE_COURSE_CONTENT_SUCCESS = 'CREATE_COURSE_CONTENT_SUCCESS';
export const CREATE_COURSE_CONTENT_FAILURE = 'CREATE_COURSE_CONTENT_FAILURE';

export const UPDATE_COURSE_CONTENT_REQUEST = 'UPDATE_COURSE_CONTENT_REQUEST';
export const UPDATE_COURSE_CONTENT_SUCCESS = 'UPDATE_COURSE_CONTENT_SUCCESS';
export const UPDATE_COURSE_CONTENT_FAILURE = 'UPDATE_COURSE_CONTENT_FAILURE';

export const DELETE_COURSE_CONTENT_REQUEST = 'DELETE_COURSE_CONTENT_REQUEST';
export const DELETE_COURSE_CONTENT_SUCCESS = 'DELETE_COURSE_CONTENT_SUCCESS';
export const DELETE_COURSE_CONTENT_FAILURE = 'DELETE_COURSE_CONTENT_FAILURE';

export const REORDER_COURSE_CONTENTS_REQUEST = 'REORDER_COURSE_CONTENTS_REQUEST';
export const REORDER_COURSE_CONTENTS_SUCCESS = 'REORDER_COURSE_CONTENTS_SUCCESS';
export const REORDER_COURSE_CONTENTS_FAILURE = 'REORDER_COURSE_CONTENTS_FAILURE';

export const FETCH_COURSE_CONTENT_STATS_REQUEST = 'FETCH_COURSE_CONTENT_STATS_REQUEST';
export const FETCH_COURSE_CONTENT_STATS_SUCCESS = 'FETCH_COURSE_CONTENT_STATS_SUCCESS';
export const FETCH_COURSE_CONTENT_STATS_FAILURE = 'FETCH_COURSE_CONTENT_STATS_FAILURE';

export const UPLOAD_MUX_VIDEO_REQUEST = 'UPLOAD_MUX_VIDEO_REQUEST';
export const UPLOAD_MUX_VIDEO_SUCCESS = 'UPLOAD_MUX_VIDEO_SUCCESS';
export const UPLOAD_MUX_VIDEO_FAILURE = 'UPLOAD_MUX_VIDEO_FAILURE';

export const CLEAR_COURSE_CONTENT_ERROR = 'CLEAR_COURSE_CONTENT_ERROR';
export const RESET_COURSE_CONTENT_STATE = 'RESET_COURSE_CONTENT_STATE';
